import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function YardIcon(props: IconProps) {
    return <Icon {...props} iconKey={"yard"}/>
}
